import { FacetOperator } from "@/utils/search/types/searchConfiguration";

import { Facet } from "./@types/facet.types";
import { createSortBy, RefinementSort, SortFunction } from "./facetSortBy";

type CustomeSortings = {
    condition: <T extends Facet<any>>(facet: T) => boolean;
    handler: SortFunction;
};

export const SHOW_PRODUCTS_FACET = "showProductsFacet";

const CONJUNCTIVE_FACET_ATTRIBUTES = ["showProductsFacet"];
export const getOperator = (attribute: string) =>
    CONJUNCTIVE_FACET_ATTRIBUTES.includes(attribute)
        ? FacetOperator.AND
        : FacetOperator.OR;

export const FACET_SHOWMORE_LIMIT = 5;
export const HIERARCHICAL_FACET_SHOWMORE_LIMIT = 10;

export const FACET_DELIMITER = "###";
export const FACET_VALUE_STORE_STOCK_IDENTIFIER = "STORE_STOCK";

export const CATEGORY_PAGE_IDS = "categoryPageIds";

const BRAND_FACET_NAMES = ["Merk", "Marque"];

export const FACET_SORT_BY = createSortBy([
    RefinementSort.IS_REFINED_DESC,
    RefinementSort.NAME_ASC,
    RefinementSort.COUNT_ASC
]);
const BRAND_FACET_SORT_BY = createSortBy([
    RefinementSort.IS_REFINED_DESC,
    RefinementSort.BRAND_HUBO,
    RefinementSort.NAME_ASC,
    RefinementSort.COUNT_ASC
]);
const RATING_SORT_BY_DESC = createSortBy([RefinementSort.NAME_DESC]);
export const HIERARCHICAL_FACET_SORT_BY = createSortBy([
    RefinementSort.COUNT_DESC,
    RefinementSort.NAME_ASC
]);

const CustomSorting: Array<CustomeSortings> = [
    {
        condition: (facet) =>
            BRAND_FACET_NAMES.some(
                (bfn) => bfn.toLowerCase() === facet.name.toLowerCase()
            ),
        handler: BRAND_FACET_SORT_BY
    },
    {
        condition: (facet) =>
            facet.name.toLowerCase() === "averageRatingFacet".toLowerCase(),
        handler: RATING_SORT_BY_DESC
    }
];

export const CustomSortingFor = <T extends Facet<any>>(facet: T) => {
    return CustomSorting.find((cs) => cs.condition<T>(facet))?.handler;
};
